import getLogger from '@ignitesales/logger-es';

const logger = getLogger();

const OneSecDelay = (func) => {
  window.setTimeout(func, 1000);
};

const mockContactService = {
  submitContact: async (contact) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        logger.info('Contact Submitted', contact);
        const result = {
          status: 'success',
        };
        resolve(result);
      }, 1000);
    });
  },

  sendLead: async () => {
    logger.info('sendLead');
  },

  saveForLater: async () => {
    logger.info('saveForLater');
  },

  emailResults: async () => {
    logger.info('emailResults');
  },

  textResults: async () => {
    logger.info('textResults');
  },

  contactSubmitted: async (contact) => {
    logger.debug('entered contactSubmitted()', contact);
    return new Promise((resolve) => {
      OneSecDelay(() => {
        logger.info('Contact Submitted', contact);
        resolve({
          status: 'success',
          contact,
        });
      });
    });
  },
};

export default mockContactService;
